// ============================================================================
// SYUT ENGAGEMENT TYPE SELECT
// ============================================================================
// Domain wrapper around SyutSelect for the Engagement Type master.

import React from 'react';
import { SyutSelect } from '../SyutSelect';
import { engagementTypeService } from 'api/services/engagementTypeService';

export interface SyutEngagementTypeSelectProps {
  value?: string;
  onChange: (value: string) => void;
  label?: React.ReactNode;
  error?: string;
  required?: boolean;
  isClearable?: boolean;
  placeholder?: string;
  size?: 'sm' | 'md' | 'lg';
  seedOptions?: { value: string; label: string }[];
  includeInactive?: boolean;
  pageSize?: number;
  disabled?: boolean;
}

export const SyutEngagementTypeSelect: React.FC<SyutEngagementTypeSelectProps> = ({
  value,
  onChange,
  label,
  error,
  required,
  isClearable = false,
  placeholder = 'Search engagement types...',
  size = 'sm',
  seedOptions,
  includeInactive = false,
  pageSize = 500,
  disabled,
}) => (
  <SyutSelect
    label={label}
    value={value}
    isAsync
    loadOptions={async (input: string) => {
      const res = await engagementTypeService.getAll({
        page: 1,
        pageSize,
        searchTerm: input || undefined,
        includeInactive,
      });
      return res.data.map((et: any) => ({ value: et.id, label: et.name }));
    }}
    defaultOptions
    cacheOptions={false}
    seedOptions={seedOptions}
    debounceDelay={300}
    minSearchLength={1}
    isClearable={isClearable}
    size={size}
    placeholder={placeholder}
    error={error}
    required={required}
    isDisabled={disabled}
    onChange={(val) => onChange((val as string) || '')}
  />
);

export default SyutEngagementTypeSelect;
